import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';

@Injectable()
export class AccountService extends WebService {

    public getAccount(): Observable<Response> {
        this.refreshToken();
        return this.http.get( `${this.apiUrl}/profile?_with=roles,employee.department.venue.company`, { headers: this.headers });
    }
    public getAccountCandidate(): Observable<Response> {
        this.refreshToken();
        return this.http.get( `${this.apiUrl}/profile?_with=roles,candidate`, { headers: this.headers });
    }
    public getAccountPermissions(): Observable<Response> {
        return this.http.get( `${this.apiUrl}/profile/permissions`, { headers: this.headers } );
    }
    public getAccountAvatar(): Observable<Response> {
        return this.http.get( `${this.apiUrl}/profile/avatar`,
            { headers: this.headers } );
    }
    public getAccountOwner(): Observable<Response> {
        return this.http.get( `${this.apiUrl}/profile?_with=account`, { headers: this.headers } );
    }
    public addUser(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/auth/signup`, JSON.stringify(body), { headers: this.headers } );
    }
    public passwordReset(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/auth/password_reset`, JSON.stringify(body), { headers: this.headers } );
    }
    public activateAccount(body: object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/auth/activate`, JSON.stringify(body), { headers: this.headers } );
    }
    public updateProfile(body: object):  Observable<Response> {
        return this.http.patch( `${this.apiUrl}/profile`, JSON.stringify(body), { headers: this.headers } );
    }
    public updatePassword(body: object):  Observable<Response> {
        return this.http.patch( `${this.apiUrl}/profile/password`, JSON.stringify(body), { headers: this.headers } );        
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/account/account.service.ts